'use client';

import { useEffect } from 'react';
import { IncomingCallHost, callPresenceBus, handleServiceWorkerMessage } from '@/modules/calls';

export function CallProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    callPresenceBus.connect();

    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener(
        'message',
        handleServiceWorkerMessage
      );
    }

    return () => {
      callPresenceBus.disconnect();
      if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener(
          'message',
          handleServiceWorkerMessage
        );
      }
    };
  }, []);

  return (
    <>
      {children}
      <IncomingCallHost />
    </>
  );
}
